module.exports = __webpack_public_path__ + "img/3.9170b95a.jpg";